<div class="dialog-container">
    <!-- Header -->
    <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
        <h4 class="dialog-title mb-0">{{ isEditMode ? 'Edit ' + getLookupTypeLabel() : 'Add ' + getLookupTypeLabel() }}</h4>
        <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close dialog">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <!-- Form -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <ng-container *ngFor="let field of fields">
            <!-- Toggle field -->
            <div class="form-group mb-3" *ngIf="field.type === 'toggle'">
                <div class="d-flex align-items-center gap-3">
                    <label class="form-label mb-0">{{ field.label }}</label>
                    <div class="toggle-wrapper">
                        <input
                            type="checkbox"
                            [id]="field.name"
                            [formControlName]="field.name"
                            class="toggle-input">
                        <label [for]="field.name" class="toggle-label"></label>
                    </div>
                </div>
            </div>

            <!-- Number field -->
            <div class="form-group mb-3" *ngIf="field.type === 'number'">
                <label [for]="field.name" class="form-label">
                    {{ field.label }}
                    <span class="required-asterisk" *ngIf="field.required">*</span>
                </label>
                <input
                    type="number"
                    [id]="field.name"
                    class="form-control"
                    [formControlName]="field.name"
                    [class.is-invalid]="isFieldInvalid(field.name)">
                <div *ngIf="isFieldInvalid(field.name)" class="invalid-feedback">{{ field.label }} is required</div>
            </div>

            <!-- Text field -->
            <div class="form-group mb-3" *ngIf="field.type === 'text' || field.type === 'textarea'">
                <label [for]="field.name" class="form-label">
                    {{ field.label }}
                    <span class="required-asterisk" *ngIf="field.required">*</span>
                </label>
                <textarea
                    *ngIf="field.type === 'textarea'"
                    [id]="field.name"
                    class="form-control"
                    [formControlName]="field.name"
                    rows="3"
                    [class.is-invalid]="isFieldInvalid(field.name)">
                </textarea>
                <input
                    *ngIf="field.type === 'text'"
                    type="text"
                    [id]="field.name"
                    class="form-control"
                    [formControlName]="field.name"
                    [class.is-invalid]="isFieldInvalid(field.name)">
                <div *ngIf="isFieldInvalid(field.name)" class="invalid-feedback">{{ field.label }} is required</div>
            </div>
        </ng-container>

        <!-- Footer -->
        <div class="dialog-footer d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn cancel-btn" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn submit-btn">{{ isEditMode ? 'Update' : 'Add' }}</button>
        </div>
    </form>
</div>
